'use client';

import LiveSearchBar from '@/components/search/LiveSearchBar';

export default function StoresSearchBar() {
  return (
    <LiveSearchBar
      variant="hero"
      placeholder="Search stores…"
    />
  );
}
